import { useMemo } from 'react';

import { getQrCodeFileName } from '@/features/download/utils/getQrCodeFileName';
import { buildSrc } from '@/integrations/image-kit';

export function DownloadModalQrCode() {
  const qrCodeImageUrl = useMemo(
    () =>
      buildSrc({
        src: `/duos-storage/qr/${getQrCodeFileName()}`,
        transformation: [{ dpr: 2 }],
      }),
    [],
  );

  return (
    <div className="mt-4 flex items-center">
      <img
        src={qrCodeImageUrl}
        alt="QR Code for app download"
        className="size-75"
      />
    </div>
  );
}
